export default "__VITE_ASSET__CkuMlBua__"